import React, { useState, useEffect } from "react";
import "./About.scss";
import { motion } from "framer-motion";
import { urlFor, client } from "../../client";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => setAbouts(data));
  }, []);

  return (
    <>
      <h2 className="head-text">
        A little
        <span> About me</span>
      </h2>
      <p className="about__me">
        Welcome to my portfolio! I'm a passionate full-stack web developer who
        specializes in creating captivating websites for startups using
        JavaScript, React, Ruby on Rails, and Python. With a Computer Science
        degree and Microverse training, I combine technical expertise with a
        keen interest in emerging technologies. My portfolio showcases projects
        that embody innovation and problem-solving, reflecting my commitment to
        excellence. Let's collaborate to bring your digital ideas to life and
        shape the future of the web.
      </p>

      <div className="app__profile">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.2 }}
            transition={{ duration: 0.2, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20, textAlign: 'center' }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "About",
  "app__whitebg"
);
